import { Pipe, PipeTransform } from '@angular/core';
import { SelectOption, VehicleOwnershipEnum, VehicleOwnershipsOptions } from '@fleet-beat/core';

@Pipe({
  name: 'vehicleOwnershipPipe',
})
export class VehicleOwnershipPipe implements PipeTransform {
  transform(value: VehicleOwnershipEnum): string | null {
    if (!value) return null;
    return VehicleOwnershipsOptions.find((role: SelectOption) => role.value === value).label;
  }
}
